export class PromotionsApiConverter {
  convertPoints = data => {
    return ({
      myPoints: data.user_points,
      cashiersList: data?.rating
        // ?.sort((a, b) => b.point_balance - a.point_balance)
        ?.map((v, i) => ({
          id: v.user_id,
          points: v.point_balance,
          place: i + 1,
        }))
    })
  }

  convertSuperadminBonusGrade = grade => {
    if (!grade) return null;

    return {
      id: String(grade.code || '').toLowerCase(),
      name: grade.title || '',
      minDepositUsdt: grade.min_usd ?? 0,
      depositBonusPercent: grade.deposit_bonus_percent ?? 0,
      transitionBonusUsd: grade.transition_bonus_usd ?? 0,
      nextLevelDepositUsdt: grade.next_threshold_usd ?? null,
    };
  };

  convertSuperadminBonusSistem = data => {
    const currentGrade = this.convertSuperadminBonusGrade(data?.current_grade);
    const nextGrade = this.convertSuperadminBonusGrade(data?.next_grade);
    
    return {
      period: data?.period ?? null,
      currentGrade,
      nextGrade,
      amountDepositsLast30Days: data?.total_usd_deposits ?? 0,
      remainingToNextUsdt: data?.remaining_usd_to_next_grade ?? 0,
      progressToNextLevelPercent: data?.progress_percent ?? 0,
      paidTransitionGrades: data?.paid_transition_grades ?? [],
      updatedAt: data?.updated_at ?? null,
    };
  };
}
